import { Collapse, Button } from 'antd';
import Typography from 'helpers/fonts';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Colors from '../colors';
import './color-palette.css';

export interface ColorPaletteProps {
  selectedColor: string | null;
  colors: string[];
  onSelectColor: (color: string | null) => void;
  description: string;
}

const ColorPalette: React.FunctionComponent<ColorPaletteProps> = ({
  colors,
  selectedColor,
  onSelectColor,
  description
}) => {
  const { t } = useTranslation();

  return (
    <Collapse ghost style={{ maxWidth: '370px', marginLeft: '-16px' }}>
      <Collapse.Panel
        header={
          <Typography styleid={10}>
            {t('materialsSidebar.colorPaletteTitle')}
          </Typography>
        }
        key="1"
      >
        <div style={{ marginLeft: '20px' }}>
          <p>
            <Typography styleid={9}>
              { description }
            </Typography>
          </p>

          <Colors
            colors={colors}
            selectedColor={selectedColor}
            onSelectColor={onSelectColor}
          />
          <Button type="text" danger onClick={() => onSelectColor(null)} style={{ padding: 0 }}>
            {t('materialsSidebar.resetColor')}
          </Button>
        </div>
      </Collapse.Panel>
    </Collapse>
  );
};

export default ColorPalette;
